var map = {
	"./Kalutara Bodhiya hero.jpg": 923,
	"./Kalutara-Beach-hero.jpg": 624,
	"./Kalutara-beach.jpg": 721,
	"./Richmond Castle hero.jpg": 880,
	"./Richmond castle Kalutara.jpg": 387,
	"./about-1.jpg": 823,
	"./accommodation.jpg": 946,
	"./cabana.png": 420,
	"./cocktail.png": 62,
	"./deluxe-1.jpg": 831,
	"./deluxe-2.jpg": 984,
	"./deluxe-3.jpg": 165,
	"./deluxe-4.jpg": 750,
	"./dining.jpg": 943,
	"./dinning-1.jpg": 127,
	"./dinning-2.jpg": 792,
	"./dinning-3.jpg": 365,
	"./dinning-4.jpg": 918,
	"./dinning-5.jpg": 443,
	"./dinning-6.jpg": 964,
	"./food-bg.jpg": 830,
	"./hero.jpg": 480,
	"./hero1.webp": 25,
	"./hero2.jpg": 776,
	"./hero3.jpg": 941,
	"./hero4.jpeg": 363,
	"./kalutara-bodhiya.jpg": 708,
	"./logo.png": 153,
	"./pool.png": 974,
	"./resort1.jpg": 966,
	"./resort2.jpg": 105,
	"./resort3.jpg": 732,
	"./room.png": 273,
	"./vision-bg.jpg": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;